export default "__VITE_ASSET__DjNlqyAe__"